import React from "react";
import { SiReact } from "react-icons/si";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import "./WorkExp.css";
const WorkExp = () => {
  return (
    <>
      <div className="work" id="work">
        <div className="container work-exp">
          <h2 className="col-12 mt-3 mb-1 text-center text-uppercase">
            Work Experience
          </h2>
          <p className="text-center" style={{ fontSize: '16px', color: '#666', marginBottom: '20px' }}>
            <strong>Total Experience: 1.5+ years</strong> | Mobile Development & Full-Stack  
          </p>
          <hr />
          <VerticalTimeline lineColor="#1e1e2c">
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{ background: "white", color: "#1e1e2c" }}
              contentArrowStyle={{
                borderRight: "7px solid  white",
              }}
              date="Jan 2025 - Present"
              iconStyle={{ background: "#1e1e2c", color: "#fff" }}
              icon={<SiReact />}
            >
              <h3 className="vertical-timeline-element-title">
                App Developer
              </h3>
              <h4 className="vertical-timeline-element-subtitle">
                Jabsz Studios LLP · Gurugram, India
              </h4>
              <div className="work-exp-points">
                <div className="work-exp-point">
                  – Developed and deployed a cross-platform mobile application with 10+ interactive games, improving user engagement.
                </div>
                <div className="work-exp-point">
                  – Led full-stack development including frontend, backend integration, and Play Store deployment.
                </div>
                <div className="work-exp-point">
                  – Integrated ads, sound systems, and optimized app performance for smooth user experience.
                </div>
                <div className="work-exp-point">
                  – Mentored interns and improved development workflow efficiency.
                </div>
                <div className="work-exp-point">
                  – <strong>Live:</strong> <a href="https://play.google.com/store/apps/details?id=com.JabszGamingStudios.KnowledgeBubble&hl=en_IN" target="_blank" rel="noopener noreferrer">Knowledge Bubble</a>
                </div>
              </div>
            </VerticalTimelineElement>

            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{ background: "white", color: "#1e1e2c" }}
              contentArrowStyle={{
                borderRight: "7px solid  white",
              }}
              date="Dec 2025 - February 2026"
              iconStyle={{ background: "#f59e0b", color: "#fff" }}
              icon={<SiReact />}
            >
              <h3 className="vertical-timeline-element-title">
                Freelance React Native Developer
              </h3>
              <h4 className="vertical-timeline-element-subtitle">
                BT-Traders Mobile Application (Live)
              </h4>
              <div className="work-exp-points">
                <div className="work-exp-point">
                  – Designed and developed a subscription-based trading mobile application for gold and commodity traders.
                </div>
                <div className="work-exp-point">
                  – Successfully launched Version 1.0 on Google Play Store, handling complete development and deployment lifecycle.
                </div>
                <div className="work-exp-point">
                  – Implemented secure authentication system with JWT and Firebase, including login, registration, and session management.
                </div>
                <div className="work-exp-point">
                  – Built scalable backend using Firebase and REST APIs supporting real-time data updates and user access control.
                </div>
                <div className="work-exp-point">
                  – <strong>Live:</strong> <a href="https://play.google.com/store/apps/details?id=com.sadhak.bttraders" target="_blank" rel="noopener noreferrer">BT-Traders app</a>
                </div>
              </div>
            </VerticalTimelineElement>

            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{ background: "white", color: "#1e1e2c" }}
              contentArrowStyle={{
                borderRight: "7px solid  white",
              }}
              date="Oct 2025 - March 2026"
              iconStyle={{ background: "#1e1e2c", color: "#fff" }}
              icon={<SiReact />}
            >
              <h3 className="vertical-timeline-element-title">
                Full Stack Developer
              </h3>
              <h4 className="vertical-timeline-element-subtitle">
                NR Innovium Technologies · MB Academy
              </h4>
              <div className="work-exp-points">
                <div className="work-exp-point">
                  – Led end-to-end full stack development of MB Academy (LMS), designing scalable architecture, REST APIs, and optimized database schemas.
                </div>
                <div className="work-exp-point">
                  – Implemented secure payment gateways, subscription workflows, and admin-controlled course management.
                </div>
                <div className="work-exp-point">
                  – Built scalable admin systems and role-based dashboards supporting platform operations and content delivery.
                </div>
                <div className="work-exp-point">
                  – Developed internal CRM tools to streamline lead tracking, task assignment, and operations.
                </div>
                <div className="work-exp-point">
                  – <strong>Live:</strong> <a href="https://mbacademy.co.in/" target="_blank" rel="noopener noreferrer">mbacademy.co.in</a>
                </div>
              </div>
            </VerticalTimelineElement>

            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{ background: "white", color: "#1e1e2c" }}
              contentArrowStyle={{
                borderRight: "7px solid  white",
              }}
              date="Sep 2024 - Nov 2024"
              iconStyle={{ background: "#1e1e2c", color: "#fff" }}
              icon={<SiReact />}
            >
              <h3 className="vertical-timeline-element-title">
                Full Stack Development Intern
              </h3>
              <h4 className="vertical-timeline-element-subtitle">
                Innomatics Research Labs
              </h4>
              <div className="work-exp-points">
                <div className="work-exp-point">
                  – Created responsive web templates using front-end technologies, demonstrating UI/UX design skills.
                </div>
                <div className="work-exp-point">
                  – Developed React-powered student management dashboards with interactive components and data visualization.
                </div>
                <div className="work-exp-point">
                  – Built full-stack MERN applications, including e-commerce platform and todo application.
                </div>
              </div>
            </VerticalTimelineElement>


          </VerticalTimeline>
        </div>
      </div>
    </>
  );
};

export default WorkExp;
